import mutations from './mutations';
import actions from './actions';

const initialState = {
  open: false
};

const drawer = {
  namespaced: true,
  state: { ...initialState },
  mutations,
  actions,
  getters: {}
};

export default drawer;
